import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addHandOver, getCompanydata, signOut } from "../store/adminSlice";
import { adminActions } from "../store/adminSlice";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import escapeHtml from "../functions/Validator";
import Swal from "sweetalert2";
import logoo from "../pictures/TheBestescafflogo.png";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";

function Form() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const stateSwalAlert = useSelector((state) => state.admin.swalAlert);
  const queryParameters = new URLSearchParams(window.location.search);
  const companyDetails = useSelector((state) => state.admin.companyDetails);
  const id = queryParameters.get("id");
  const clientName = queryParameters.get("clientName");
  const address = queryParameters.get("address");
  const postcode = queryParameters.get("postcode");
  const adminID = useSelector((state) => state.admin._id);
  const [data, setData] = useState({
    customerID: id,
    clientName,
    address,
    postcode,
    dateOfScoffolldingCompletion: "",
    time: "",
    descriptionHandover: "",
    drawingNo: "",
    MaximumLoading: "",
    methodOfTyping: "",
    tiesBeenTested: "",
    methodOfCladding: "",
    handover: "",
    detailsNessesary: "",
    scaffoldingContractor: "",
    scaffolderEmail: "",
    adminID: adminID,
  });
  const statesignOut = useSelector((state) => state.admin.signOut);
  useEffect(() => {
    if (statesignOut === "signOut") {
      dispatch(signOut());
    }
  }, [statesignOut]);
  const onChangeDate = (e) => {
    const newDate = moment(new Date(e.target.value)).format("YYYY-MM-DD");
    setData({ ...data, dateOfScoffolldingCompletion: newDate });
    // setData({ ...data, customerID: stateSingleJob.customer._id })
  };
  const handleHandover = () => {
    dispatch(addHandOver(data));
  };
  useEffect(() => {
    if (stateSwalAlert === "handoverAdded") {
      Swal.fire({
        icon: "success",
        title: "Saved",
        confirmButtonColor: "#60c088",
      }).then(() => {
        dispatch(adminActions.removeSwalAlert());
        navigate("/liveprojects");
      });
    }
  }, [stateSwalAlert]);
  useEffect(() => {
    setData({
      ...data,
      scaffoldingContractor: companyDetails.customerOrCompanyName,
    });
    console.log(companyDetails, "with dependency");
  }, [companyDetails]);
  useEffect(() => {
    dispatch(getCompanydata(adminID));
    setData({
      ...data,
      scaffoldingContractor: companyDetails.customerOrCompanyName,
    });
    console.log(companyDetails, "without dependency");
  }, []);

  return (
    <div className="w-full flex flex-col h-full bg-gray-50">
      {/* Header with back button */}
      <div className="w-full bg-white shadow-md px-4 py-3 flex justify-between items-center">
        <div className="flex items-center">
          <button
            onClick={() => navigate(-1)}
            className="mr-3 text-gray-700 hover:text-lightgreen transition-colors"
          >
            <ArrowBackIcon />
          </button>
          <img src={logoo} alt="Escaff Logo" className="h-10" />
        </div>
        <button
          onClick={() => navigate("/liveprojects")}
          className="text-gray-500 hover:text-lightgreen transition-colors"
        >
          <CloseIcon />
        </button>
      </div>

      <div className="max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-6">
        <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
          <h2 className="text-lg sm:text-xl font-medium text-gray-800 mb-6">
            Scaffolding Handover
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Left Column */}
            <div className="space-y-5">
              <div className="space-y-2">
                <label className="block text-sm font-medium text-gray-700">
                  Client name
                </label>
                <input
                  className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                  type="text"
                  onWheel={(e) => e.target.blur()}
                  value={data.clientName}
                  onChange={(e) =>
                    setData({ ...data, clientName: escapeHtml(e.target.value) })
                  }
                  required
                />
              </div>

              <div className="space-y-2">
                <label className="block text-sm font-medium text-gray-700">
                  Address
                </label>
                <input
                  className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                  type="text"
                  onWheel={(e) => e.target.blur()}
                  value={data.address}
                  onChange={(e) =>
                    setData({ ...data, address: escapeHtml(e.target.value) })
                  }
                  required
                />
              </div>

              <div className="space-y-2">
                <label className="block text-sm font-medium text-gray-700">
                  Post code
                </label>
                <input
                  className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                  type="text"
                  onWheel={(e) => e.target.blur()}
                  value={data.postcode}
                  onChange={(e) =>
                    setData({ ...data, postcode: escapeHtml(e.target.value) })
                  }
                  required
                />
              </div>

              <div className="space-y-2">
                <label className="block text-sm font-medium text-gray-700">
                  Date scaffolding Completion
                </label>
                <input
                  className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                  type="date"
                  value={data.dateOfScoffolldingCompletion}
                  onChange={onChangeDate}
                  required
                />
              </div>

              <div className="space-y-2">
                <label className="block text-sm font-medium text-gray-700">
                  Time
                </label>
                <input
                  className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                  type="text"
                  onWheel={(e) => e.target.blur()}
                  value={data.time}
                  onChange={(e) =>
                    setData({ ...data, time: escapeHtml(e.target.value) })
                  }
                  required
                />
              </div>

              <div className="pt-3">
                <h3 className="text-md font-medium text-gray-800 mb-3">
                  Scaffold specification
                </h3>
                <p className="text-sm text-gray-600 mb-4">
                  In accordance with The working at height Regulations 2005 this
                  scaffold must be inspected by the User and a record maintained
                  of the inspections as follows; Before being taken into use for
                  the first time After substantial addition, dismantling or
                  other alterations After any event likely to have affected its
                  strength or stability At regular intervals not exceeding 7
                  days
                </p>

                <p className="text-sm font-medium text-gray-700 mb-4">
                  The inside boards only take a loading limit of 0.75kn/m2
                </p>
              </div>

              <div className="space-y-2">
                <label className="block text-sm font-medium text-gray-700">
                  Description of section handed over
                </label>
                <textarea
                  className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                  rows="3"
                  value={data.descriptionHandover}
                  onChange={(e) =>
                    setData({
                      ...data,
                      descriptionHandover: escapeHtml(e.target.value),
                    })
                  }
                />
              </div>

              <div className="space-y-2">
                <label className="block text-sm font-medium text-gray-700">
                  Drawing No/TG20:21 compliance sheet ref:
                </label>
                <input
                  className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                  type="text"
                  onWheel={(e) => e.target.blur()}
                  value={data.drawingNo}
                  onChange={(e) =>
                    setData({ ...data, drawingNo: escapeHtml(e.target.value) })
                  }
                  required
                />
              </div>

              <div className="space-y-2">
                <label className="block text-sm font-medium text-gray-700">
                  Maximum loading
                </label>
                <input
                  className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                  type="text"
                  onWheel={(e) => e.target.blur()}
                  value={data.MaximumLoading}
                  onChange={(e) =>
                    setData({
                      ...data,
                      MaximumLoading: escapeHtml(e.target.value),
                    })
                  }
                  required
                />
              </div>
            </div>

            {/* Right Column */}
            <div className="space-y-5">
              <div className="space-y-2">
                <label className="block text-sm font-medium text-gray-700">
                  Method of tying
                </label>
                <input
                  className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                  type="text"
                  onWheel={(e) => e.target.blur()}
                  value={data.methodOfTyping}
                  onChange={(e) =>
                    setData({
                      ...data,
                      methodOfTyping: escapeHtml(e.target.value),
                    })
                  }
                  required
                />
              </div>

              <div className="space-y-2">
                <label className="block text-sm font-medium text-gray-700">
                  Have the ties been tested?
                </label>
                <select
                  className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                  value={data.tiesBeenTested}
                  onChange={(e) =>
                    setData({
                      ...data,
                      tiesBeenTested: escapeHtml(e.target.value),
                    })
                  }
                >
                  <option value="">Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>

              <div className="space-y-2">
                <label className="block text-sm font-medium text-gray-700">
                  Method of cladding
                </label>
                <input
                  className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                  type="text"
                  onWheel={(e) => e.target.blur()}
                  value={data.methodOfCladding}
                  onChange={(e) =>
                    setData({
                      ...data,
                      methodOfCladding: escapeHtml(e.target.value),
                    })
                  }
                  required
                />
              </div>

              <div className="pt-3">
                <h3 className="text-md font-medium text-gray-800 mb-3">
                  Handover
                </h3>
                <p className="text-sm text-gray-600 mb-4">
                  The scaffolding as described above has now been completed in
                  accordance with client requirements. It is structurally sound
                  and should only be used, cladded and loaded in accordance with
                  this handover certificate.
                </p>

                <p className="text-sm text-gray-600 mb-4">
                  Have the requirements of the work at heights regulations 2005
                  and any other relevant legislation and NASC guidance such as
                  SG4 and TG20:21 been compiled with?
                </p>
              </div>

              <div className="space-y-2">
                <select
                  className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                  value={data.handover}
                  onChange={(e) =>
                    setData({ ...data, handover: escapeHtml(e.target.value) })
                  }
                >
                  <option value="">Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>

              <div className="space-y-2">
                <label className="block text-sm font-medium text-gray-700">
                  Details of any further action considered necessary:
                </label>
                <textarea
                  className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                  rows="3"
                  value={data.detailsNessesary}
                  onChange={(e) =>
                    setData({
                      ...data,
                      detailsNessesary: escapeHtml(e.target.value),
                    })
                  }
                />
              </div>

              <div className="pt-3">
                <h3 className="text-md font-medium text-gray-800 mb-3">
                  Acceptance
                </h3>
                <p className="text-sm text-gray-600 mb-4">
                  We accept that the scaffold must be inspected by a competent
                  person at intervals not exceeding seven days and after any
                  event that may affect its adequacy. We (the client) will not
                  modify the scaffold without authorisation and the scaffold
                  will be used within the parameters set out within this
                  document.
                </p>
              </div>

              <div className="space-y-2">
                <label className="block text-sm font-medium text-gray-700">
                  Name of Company
                </label>
                <input
                  className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                  type="text"
                  value={data.scaffoldingContractor}
                  onWheel={(e) => e.target.blur()}
                  onChange={(e) =>
                    setData({
                      ...data,
                      scaffoldingContractor: escapeHtml(e.target.value),
                    })
                  }
                  required
                />
              </div>

              <div className="space-y-2">
                <label className="block text-sm font-medium text-gray-700">
                  Name of Scaffolder
                </label>
                <input
                  className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                  type="text"
                  onWheel={(e) => e.target.blur()}
                  onChange={(e) =>
                    setData({
                      ...data,
                      scaffolderEmail: escapeHtml(e.target.value),
                    })
                  }
                  required
                />
              </div>
            </div>
          </div>

          <div className="flex justify-between mt-8">
            <button
              className="px-6 py-2 bg-lightgreen hover:bg-darkgreen text-white font-medium rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-lightgreen transition-colors"
              onClick={handleHandover}
            >
              Submit Handover
            </button>
            <button
              className="px-6 py-2 border border-lightgreen text-lightgreen hover:bg-gray-50 font-medium rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-lightgreen transition-colors"
              onClick={() => navigate(-1)}
            >
              Back
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Form;
